import { render, staticRenderFns } from "./DropDownItem.vue?vue&type=template&id=588f9ad0&scoped=true&"
import script from "./DropDownItem.vue?vue&type=script&lang=js&"
export * from "./DropDownItem.vue?vue&type=script&lang=js&"
import style0 from "./DropDownItem.vue?vue&type=style&index=0&id=588f9ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f9ad0",
  null
  
)

export default component.exports